import Emitter from 'tiny-emitter';

var bus = new Emitter();
export default bus;
